import { Component, OnInit, ViewChild, TemplateRef, Input, Output, EventEmitter, OnDestroy, ViewChildren, QueryList, Renderer2 } from '@angular/core';
import { DataTablesResponse } from '../../../shared/models/datatables-response';
import { DataTablesModule, DataTableDirective } from 'angular-datatables';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { AuthenticationService } from '../../../shared/auth/authentication.service';
import { EmailValidator, ValidationService } from '../../../shared/providers/validation.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ToastService } from '../../../shared/providers/toast.service';
import { LoaderService } from '../../../shared/providers/loader.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Subject, Subscription } from 'rxjs';
import { PropertyListingService } from '../../../shared/providers/property-listing.service';
import { CommonService } from '../../../shared/providers/common.service';
import { PortfolioContactInput } from '../../../shared/models/PortfolioContactInput';
import { RestService } from '../../../shared/providers/rest.service';
import { PropertyManagementService } from '../../../shared/providers/property-management.service';
import { v4 as uuidv4 } from 'uuid';
import { ActivatedRoute } from '@angular/router';
import { defaultValidator } from '../../../shared/models/SavePropertyInputModel';
import { PortfolioContactDetails } from '../../../shared/models/PortfolioContactDetails';
import { MatSelect } from '@angular/material/select';

@Component({
  selector: 'app-property-contact',
  templateUrl: './property-contact.component.html',
  styleUrls: ['./property-contact.component.css']
})
export class PropertyContactComponent implements OnInit, OnDestroy {
  private contactSubscriptions: Subscription[] = [];
  @ViewChildren(MatSelect) matSelects!: QueryList<MatSelect>;
  userId: number = 0;
  @Input() DataEntryPropertyId: number = 0;
  propertyGuid: string = '';
  dealContacts = [];
  searchText = "";
  @Input() IsPDeleted: boolean = false;
  @Input() UserGuid: string = '0000';
  modalRef: BsModalRef;
  table: DataTableDirective;
  modalRefDelete: BsModalRef;
  deleteId = 0;
  dealContactForm: FormGroup;
  showCreate = false;
  filterData: any;
  isSubmitted = false;
  propertyId: any = uuidv4();
  isInitialLoad: boolean = false;
  propertyLst = [];
  masterpropertyLst = [];
  contactDetails: PortfolioContactDetails;
  dealContactInputModel: PortfolioContactInput = {
    ContactType: null, Id: 0, FirstName: null, LastName: null, Email: null, ContactTypeId: null, UserId: this.userId, Phone: null, PropertyId: null, PropertyName: null, IsPortfolio: false, DataEntryPropertyId: null, DataEntryPropertyIds: []
  };
  selectedpropertyIds = [];
  propertyIdsPortfolio = [];
  propertyIds = [];
  userAddedProperties = [];
  contactTypes = [];
  contactTypeList = [];
  contactTypeIds = [];
  properties = [];
  userAddedPropertyList = [];
  dtOptions = {};
  dtTrigger = new Subject();
  header = "Add";
  @ViewChild('createDealTeam') accept: TemplateRef<null>;
  @ViewChild(DataTableDirective) dtElement: DataTableDirective;
  DDColumns = [];
  IsLoading = false;
  protected readonly BASE_URL: string = environment.base_url;
  //defaultCategoryText: IMultiSelectTexts = {
  //  defaultTitle: 'Filter By Property',
  //};
  //defaultContactText: IMultiSelectTexts = {
  //  defaultTitle: 'Filter By Contact type',
  //};
  //defaultUserAddedText: IMultiSelectTexts = {
  //  defaultTitle: 'Select Property/Portfolio',
  //};
  defaultTypeSettings = {
    singleSelection: false,
    text: "Filter By Contact type",
    bindvalue: 'id',
    bindlabel: 'itemName',
    itemsShowLimit: 3,
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    classes: "myclass custom-class",
    enableFilterSelectAll: false,
  };
  defaultPropertySettings = {
    singleSelection: false,
    text: "Select Property/Portfolio",
    bindvalue: 'id',
    bindlabel: 'itemName',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    enableSearchFilter: true,
    classes: "myclass custom-class",
    enableFilterSelectAll: false,
  };
  constructor(private propertyListing: PropertyListingService,
    private modalService: BsModalService, private renderer: Renderer2, private commonService: CommonService, private _toastService: ToastService, private loader: LoaderService, private http: HttpClient, private rest: RestService, private _propertyManagementService: PropertyManagementService, private _ValidationService: ValidationService, public authService: AuthenticationService, private activatedRoute: ActivatedRoute) { }

  ngOnInit() {
    this.isInitialLoad = true;
    this.UserGuid = this.UserGuid != '' ? this.UserGuid : '0000';
    this.getContactTypes();
    this.loadDealContacts();
    this.getProperties();

    //#endregion
    this.dealContactForm = new FormGroup({
      'txtFirstName': new FormControl(this.dealContactInputModel.FirstName, [
        Validators.required
      ]),
      'txtLastName': new FormControl(this.dealContactInputModel.LastName, [
        Validators.required
      ]),
      'txtEmail': new FormControl(this.dealContactInputModel.Email, [
        EmailValidator
      ]),
      'txtPhone': new FormControl(this.dealContactInputModel.Phone, [
        Validators.minLength(10)
      ]),
      'lstRole': new FormControl(this.dealContactInputModel.ContactTypeId, [
        Validators.required
      ]),
      'lstProperty': new FormControl(this.propertyId, [
        (this.DataEntryPropertyId == null || this.DataEntryPropertyId == 0) ? Validators.required : defaultValidator
      ]),
      'chkIsPortfolio': new FormControl(this.dealContactInputModel.IsPortfolio, [
        Validators.required
      ])
    });
    if (this.DataEntryPropertyId > 0) {
      this.propertyId = this.propertyGuid;
    }
    //this.getRoles();
  }
  get txtFirstName() { return this.dealContactForm.get('txtFirstName'); }
  get txtLastName() { return this.dealContactForm.get('txtLastName'); }
  get lstRole() { return this.dealContactForm.get('lstRole'); }
  get txtEmail() { return this.dealContactForm.get('txtEmail'); }
  get txtPhone() { return this.dealContactForm.get('txtPhone'); }
  get lstProperty() { return this.dealContactForm.get('lstProperty'); }
  get chkIsPortfolio() { return this.dealContactForm.get('chkIsPortfolio'); }


  loadDealContacts() {

    const that = this;
    let user: any;
    user = this.authService.user;
    this.userId = user.Id;
    if (this.selectedpropertyIds != null && this.selectedpropertyIds.length > 0) {
      this.selectedpropertyIds.forEach(element => {
        if (this.propertyLst.findIndex(f => f.Id == element) > -1) {
          let currentItem = this.propertyLst.find(f => f.Id == element)
          if (currentItem != null) {
            if (currentItem.Type == 'Property') {
              this.propertyIds.push(element);
            }
            else {
              this.propertyIdsPortfolio.push(element);
            }
          }
        }
      });
    }

    this.dtOptions = {
      pagingType: 'full_numbers',
      serverSide: true,
      processing: true,
      info: false,
      search: true,
      ordering: true,
      seaching: true,
      paging: true,
      "pageLength": 50,
      language: {
        zeroRecords: null,
        processing: `<div class="custom-dt-loader">
        <div class="circle-loader-wrapper">
          <div class="circle-loader-ring"></div>
          <img src="assets/img/logos/logo.png" class="loader-icon" />
        </div>
      </div>
     `,
      },
      "order": [[1, "asc"]],
      bLengthChange: false,
      initComplete: () => $('.dataTables_filter').css('display', 'none'),
      ajax: (dataTablesParameters: any, callback: Function) => {
        this.IsLoading = true;
        dataTablesParameters.Extra_param = {
          ContactTypes: that.contactTypeIds,
          UserId: this.userId,
          IsPortfolio: false,
          PropertyId: that.DataEntryPropertyId,
          PropertyLst: that.propertyIds,
          PortfolioLst: that.propertyIdsPortfolio,
          UserGuid: that.UserGuid
        }
        const httpHeader = this._ValidationService.GetAuthHeader();
        this.contactSubscriptions.push(that.http.post<DataTablesResponse>(
          this.BASE_URL + '/dataentryproperty/propertycontacts', dataTablesParameters, httpHeader).subscribe(resp => {
            this.isInitialLoad = false;
            that.dealContacts = resp.data ? resp.data : [];
            that.filterData = resp.data ? resp.data : [];
            if (resp) {
              callback({
                recordsTotal: resp.recordsTotal,
                recordsFiltered: resp.recordsFiltered,
                data: []
              });
              if (resp.data.length === 0) {
                $(".dataTables_paginate.paging_full_numbers").hide();
              }
              else {
                $(".dataTables_paginate.paging_full_numbers").show();
              }
              $(".paginate_button.first,.paginate_button.last").hide();
            } else {
              callback({
                recordsTotal: 0,
                recordsFiltered: 0,
                data: []
              });
              $(".dataTables_paginate.paging_full_numbers").hide();
            }
            this.IsLoading = false;
            /*  $(".paginate_button.first,.paginate_button.last").hide();*/
          }));
      },
      columns: [
        { data: 'Actions' },
        { data: 'PropertyCount' },
        { data: 'FirstName' },
        { data: 'LastName' },
        { data: 'ContactType' },
        { data: 'Email' },
        { data: 'Phone' }]
    };
  }
  create(isUpdate: boolean) {
    this.header = isUpdate ? "Update" : "Add";
    if (!isUpdate) {
      this.dealContactForm.reset();
      this.dealContactInputModel = {
        ContactType: null, Id: 0, FirstName: null, LastName: null, Email: null, ContactTypeId: null, UserId: this.userId, Phone: null, PropertyId: null, PropertyName: null, IsPortfolio: false, DataEntryPropertyId: null
      };
      this.propertyId = null;
    }
    /* this.openModal(this.accept, 'panlestyle')*/
    this.openModal(this.accept, 'portfolio-bov-modal')
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(true);
  }

  ngOnDestroy() {
    this.contactSubscriptions.forEach(sub => sub.unsubscribe());
  }

  openModal(template: TemplateRef<any>, classes) {
    this.modalRef = this.modalService.show(template, { class: classes });
    //this.propertyId = null;
    //this.getContactTypes();
    this.showCreate = true;
  }

  getContactTypes() {
    this.contactSubscriptions.push(this.commonService.GetDealContactTypes().subscribe(res => {
      this.contactTypes = res;
      this.contactTypeList = res.map(o => {
        return { id: o.Id, itemName: o.ContactType };
      });
    }));
  }

  getProperties() {
    this.contactSubscriptions.push(this._propertyManagementService.getPrincipalPortfolioProperties(this.userId, this.UserGuid, '0000').subscribe(response => {
      if (response != null && response.length > 0) {
        this.properties = response;
        const myPortfolioDefaultArray = {
          id: -1,
          name: 'Portfolio Contact',
          Type: 'MyPortfolio'
        };
        this.propertyLst = response.map(o => {
          return { id: o.Id, name: o.PropertyName, Type: o.PropertyType };
        });
        this.userAddedPropertyList = this.propertyLst;
        this.userAddedPropertyList.unshift(myPortfolioDefaultArray);
        this.masterpropertyLst = response.map(o => {
          return { id: o.Id, itemName: o.PropertyName, Type: o.PropertyType, ContactCount: o.ContactCount };
        });
        if (this.masterpropertyLst != null && this.masterpropertyLst.length > 0) {
          this.masterpropertyLst = this.masterpropertyLst.filter(o => o.ContactCount > 0)
        }
        if (this.DataEntryPropertyId > 0) {
          let property = this.properties.find(x => x.Id == this.DataEntryPropertyId && x.PropertyType == 'MyPortfolio');
          this.dealContactInputModel.DataEntryPropertyId = property.Id;
          this.propertyId = property.Guid;
        }
      }
    }));
  }

  onCheckboxChange(event) {
    if (event) {
      this.dealContactInputModel.IsPortfolio = true;
    }
    else {
      this.dealContactInputModel.IsPortfolio = false;
    }
  }
  onChange() {

  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    //this.dealContacts.filter = filterValue;
  }

  disableButton: boolean = false;
  addDealTeam() {
    this.disableButton = true;
    this.isSubmitted = true;
    if (!this.dealContactForm.invalid) {

      this.dealContactInputModel.UserId = this.userId;
      if (this.dealContactInputModel.IsPortfolio == null) {
        this.dealContactInputModel.IsPortfolio = false;
      }

      if (this.DataEntryPropertyId == null || this.DataEntryPropertyId == 0) {
        if (this.dealContactInputModel.DataEntryPropertyIds.length > 0 && this.dealContactInputModel.DataEntryPropertyIds.findIndex(f => f == -1) > -1) {
          this.dealContactInputModel.IsPortfolio = true;
          let index = this.dealContactInputModel.DataEntryPropertyIds.findIndex(f => f == -1);
          this.dealContactInputModel.DataEntryPropertyIds.splice(index, 1);
        }
        else {
          this.dealContactInputModel.IsPortfolio = false;
        }
      }
      else if (this.DataEntryPropertyId > 0) {
        let property = this.properties.find(x => x.Id == this.DataEntryPropertyId);
        this.dealContactInputModel.DataEntryPropertyId = property.Id;
        if (this.dealContactInputModel.DataEntryPropertyIds != null && this.dealContactInputModel.DataEntryPropertyIds.length > 0) {
          if (this.dealContactInputModel.DataEntryPropertyIds.findIndex(f => f == -1) > -1) {
            let index = this.dealContactInputModel.DataEntryPropertyIds.findIndex(f => f == -1);
            this.dealContactInputModel.DataEntryPropertyIds.splice(index, 1);
          }
        }
        else {
          let Ids = [];
          Ids.push(this.dealContactInputModel.DataEntryPropertyId)
          this.dealContactInputModel.DataEntryPropertyIds = Ids;
        }
        this.propertyId = property.Guid;
      }
      this.dealContactInputModel.UserGuid = this.UserGuid;
      this.propertyListing.addPortfolioContact(this.dealContactInputModel).subscribe(res => {

        this.disableButton = false;
        this.isSubmitted = false;
        if (this.dealContactInputModel.Id > 0) {
          this._toastService.addToast({
            title: 'Success',
            msg: `Contact Updated Successfully`,
            timeout: 5000,
            theme: 'bootstrap',
            position: 'bottom-right',
            type: 'success'
          });
        }
        else {
          this._toastService.addToast({
            title: 'Success',
            msg: `Contact added Successfully`,
            timeout: 5000,
            theme: 'bootstrap',
            position: 'bottom-right',
            type: 'success'
          });
        }
        this.onClose();
        this.redrawTable();
      });
    }
    else {
      this.disableButton = false;
      this.dealContactForm.updateValueAndValidity();
      this._toastService.addToast({
        title: 'Unable to save changes',
        msg: 'Some fields still have invalid data or some mandatory fields are missing.',
        timeout: 5000,
        theme: 'bootstrap',
        position: 'bottom-right',
        type: 'warning'
      });
      //this.lo.display(false);
      return;
    }
    //this.propertyId = null;
  }

  edit(deal) {
    this.propertyListing.PortfolioContactDetails(deal.MasterContactId).subscribe(res => {
      if (res != null) {
        this.contactDetails = res;
        let propertyIds = [];
        if (this.contactDetails.IsPortfolio) {
          propertyIds.push(-1);
          this.dealContactInputModel.IsPortfolio = true;
        }
        else {
          this.dealContactInputModel.IsPortfolio = false;
        }
        if (this.contactDetails.PropertyList != null && this.contactDetails.PropertyList.length > 0) {
          let Ids = this.contactDetails.PropertyList;
          Ids.forEach(element => {
            propertyIds.push(element.PropertyId);
          });
        }
        this.header = "Update";
        this.dealContactInputModel.DataEntryPropertyIds = propertyIds;
        this.dealContactInputModel.UserId = this.userId;
        this.dealContactInputModel.FirstName = deal.FirstName;
        this.dealContactInputModel.LastName = deal.LastName;
        this.dealContactInputModel.Email = deal.Email;
        this.dealContactInputModel.Phone = deal.Phone;
        this.dealContactInputModel.ContactTypeId = deal.ContactTypeId;
        this.dealContactInputModel.Id = deal.MasterContactId;
        this.create(true);
      }
    });


  }
  onClose() {
    this.modalRef.hide();
    this.showCreate = false;
    this.dealContactInputModel = {
      ContactType: null, Id: 0, FirstName: null, LastName: null, Email: null, ContactTypeId: null, UserId: this.userId, Phone: null, PropertyId: null, PropertyName: null, IsPortfolio: false, DataEntryPropertyId: null
    };
    this.propertyId = null;
  }
  delete() {
    if (this.DataEntryPropertyId > 0) {
      this.propertyListing.deletepropertyDetailsContact(this.deleteId, this.userId, this.DataEntryPropertyId).subscribe(res => {
        this.dealContactInputModel = {
          ContactType: null, Id: 0, FirstName: null, LastName: null, Email: null, ContactTypeId: null, UserId: this.userId, Phone: null, PropertyId: null, PropertyName: null, IsPortfolio: false, DataEntryPropertyId: null
        };
        this._toastService.addToast({
          title: 'Delete',
          msg: `Deleted Successfully`,
          timeout: 5000,
          theme: 'bootstrap',
          position: 'bottom-right',
          type: 'success'
        });
        this.modalRefDelete.hide();
        this.redrawTable();
      });
    }
    else {
      this.propertyListing.deletePortfolioContact(this.deleteId, this.userId).subscribe(res => {
        this.dealContactInputModel = {
          ContactType: null, Id: 0, FirstName: null, LastName: null, Email: null, ContactTypeId: null, UserId: this.userId, Phone: null, PropertyId: null, PropertyName: null, IsPortfolio: false, DataEntryPropertyId: null
        };
        this._toastService.addToast({
          title: 'Delete',
          msg: `Deleted Successfully`,
          timeout: 5000,
          theme: 'bootstrap',
          position: 'bottom-right',
          type: 'success'
        });
        this.modalRefDelete.hide();
        this.redrawTable();
      });
    }

  }
  search(text: string) {
    this.dtElement.dtInstance.then(x => x.search(text).draw());
  }
  //search(term: string) {
  //  if (!term) {
  //    this.filterData = this.dealContacts;
  //  } else {
  //    this.filterData = this.dealContacts.filter(x =>
  //      x.FirstName.trim().toLowerCase().includes(term.trim().toLowerCase()) ||
  //      x.LastName.trim().toLowerCase().includes(term.trim().toLowerCase()) ||
  //      x.Email.trim().toLowerCase().includes(term.trim().toLowerCase())
  //    );
  //  }
  //}
  openDeleteModal(template: TemplateRef<any>, classes: any, id: number) {
    this.deleteId = id;
    this.modalRefDelete = this.modalService.show(template, { class: classes });
  }
  cancel() {
    this.dealContactForm.reset();
    this.modalRef.hide();
  }

  redrawTable() {
    this.propertyIds = [];
    this.propertyIdsPortfolio = [];
    if (this.selectedpropertyIds != null && this.selectedpropertyIds.length > 0) {
      this.selectedpropertyIds.forEach(element => {
        let currentItem = this.propertyLst.find(f => f.id == element);
        if (currentItem != null) {
          if (currentItem.Type == 'Property') {
            this.propertyIds.push(element);
          }
          else {
            this.propertyIdsPortfolio.push(element);
          }
        }
      });
    }
    if (!this.isInitialLoad) {
      this.dtElement.dtInstance.then(x => x.draw(false));
    }
  }

  isportfoliochecked(id: number, checked: boolean) {
    this.propertyListing.updateIsPortfolio(id, checked, this.userId).subscribe(res => {
      if (checked)
        this._toastService.addToast({
          title: 'Success',
          msg: `Added to portfolio contacts`,
          timeout: 5000,
          theme: 'bootstrap',
          position: 'bottom-right',
          type: 'success'
        });
      else if (!checked)
        this._toastService.addToast({
          title: 'Success',
          msg: `Removed from portfolio contacts`,
          timeout: 5000,
          theme: 'bootstrap',
          position: 'bottom-right',
          type: 'success'
        });
      this.redrawTable();
    });
  }

  addClassToOverlayContainer() {
    const overlayContainer = document.querySelector('.cdk-overlay-container');
    if (overlayContainer) {
      this.renderer.addClass(overlayContainer, 'custom-overlay-container');
    }
  }
}
